<template>
<div class="print">
  <div class="print-header">
    <el-button @click="navBack">返回</el-button>
    <el-button @click="printJS">打印</el-button>
  </div>
  <div class="print-main" id="print">
    <div class="print-main-item">
      <div class="print-main-item-title">仪表抄表信息表</div>
      <div class="print-main-item-time">打印时间：2022-11-21 09:24:06</div>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%;"
        size="mini"
        border>
        <el-table-column
          prop="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="house_name"
          label="所在房产">
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="客户名称"
          width="100">
        </el-table-column>
        <el-table-column
          prop="number"
          label="仪表编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="read_number"
          label="上期读数"
          width="100">
        </el-table-column>
        <el-table-column
          prop="read_time"
          label="上期抄表日期"
          width="120">
        </el-table-column>
      </el-table>
    </div>
  </div>
  <div class="print-bottom">
    <el-button @click="navBack">返回</el-button>
    <el-button @click="printJS">打印</el-button>
  </div>
</div>
</template>

<script>
import printHtml from "print-js";
export default {
  name: "MeterNotePrint",
  data(){
    return{
      where:{},
      tableData:[],
      loading:false
    }
  },
  activated() {
    this.where=reObject(this.$route.query)
    console.log(reObject(this.$route.query))
    this.getList()
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = reObject(this.where);
      // where.is_update=0;
      ERP.getRequest({
        url: "admin/MeterNote/getMasterList",
        data: {
          where: JSON.stringify(where),
          user_type:(that.$route.query.type||0),
          customer:1,
          page: 1,
          page_size: 500
        }
      }, res => {
        if (res.code) {
          that.tableData = res.data.list.map((ret,index)=>{
            ret.index=index+1;
            return ret;
          })
        }
        that.loading = false;
        // that.multipleSelection = []
      })
    },
    printJS(){
      console.log("执行打印")
      const style = '@page {margin:10mm 10mm;size: A4;};@media print { @page {size: landscape } }'//打印时去掉眉页眉尾
      printHtml({
        printable: 'print',// 标签元素id
        type: 'html',
        header: '',
        targetStyles: ['*'],
        scanStyles:true,//打印必须加上，不然页面上的css样式无效
        style,
        onLoadingStart: () => {
          console.log("onLoadingStart")
        },
        onLoadingEnd: () => {
          console.log("onLoadingEnd")
        },
        onError:()=>{
          console.log("onError")
        },
        onPdfOpen:()=>{
          console.log("onPdfOpen")
        }
      });
    },
    navBack(){
      ERP.navigateBack()
    }
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.print{
  margin: 10px auto;
  width: 800px;
  .print-main{
    //width: 800px;
    .print-main-item{
      margin-bottom: 20px;
      //width: 800px;
      .print-main-item-title{
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
      .print-main-item-time{
        line-height: 20px;
        height: 20px;
        text-align: right;
      }
    }
  }
  .print-header{
    text-align: left;
  }
  .print-bottom{
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterNotePrint.vue